import notificationSound from '@/assets/audio/mp3/notification-sound.mp3';
import { ComponentProps, forwardRef } from 'react';

type SoundAlertProps = ComponentProps<'audio'>;

const SoundAlert = forwardRef<HTMLAudioElement, SoundAlertProps>(
  function SoundAlert({ src = notificationSound, ...audioProps }, ref) {
    return <audio ref={ref} preload="auto" src={src} {...audioProps} />;
  },
);

export default SoundAlert;
